import ApiService from '@services/api.service'
import { Notify } from 'quasar'

export const etudiantMonitoring = {
  state: {
    monitorings: [],
    monitoring: null
  },
  mutations: {
    setMonitorings(state, monitorings) {
      state.monitorings = monitorings;
    },
    setMonitoring(state, monitoring) {
      state.monitoring = monitoring
    },
  },
  actions: {
    async fetchMonitoring(context, url){
      try{
        const response = await ApiService.getRequest(url);
        context.commit('setMonitoring', response.data)
      }catch(e){
        console.error(e);
        Notify.create({
          message: "Une erreur s'est produite",
          color: 'red'
        })
      }
    },
   addEtudiantMonitoring(context, data){
     try{
       const response = ApiService.postRequest('etudiant_monitorings', data);
       context.commit('setMonitoring', response.data)
       Notify.create({
          message: 'Suivi ajouté avec succès',
          color: 'positive',
       })
     }catch(error){
       Notify.create({
          message: "Une erreur s'est produite",
          color: 'red',
       })
     }
   },
    updateEtudiantMonitoring(context, data){
     try{
     const response = ApiService.patchRequest(data.url, data);
       context.commit('setMonitoring', response.data)
       Notify.create({
          message: 'Suivi ajouté avec succès',
          color: 'positive',
       })
     }catch(error){
       Notify.create({
          message: "Une erreur s'est produite",
          color: 'red',
       })
     }
    },
    deleteEtudiantMonitoring(context, suivi){
     try{
       ApiService.deleteRequest(suivi);
       Notify.create({
         message: "Le suivi a été supprimé avec succès",
         color: "green"
       })
     }catch(error){
       console.error(error);
     }

    }
  },
  getters: {
    getMonitorings(state){
      return state.monitorings
    },
    getMonitoring(state){
      return state.monitoring
    },
  }
}
